import { PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';
import { FlexSpacer } from 'ui/flexSpacer';
import { Body2, colors, spacing, Subtitle2 } from 'ui/theme';
import { PopoverVariants } from './constants';

const TitleWrapper = styled.div`
    padding-top: ${spacing.base};
    padding-right: ${spacing.base};
    padding-left: ${spacing.base};

    [data-variant=${PopoverVariants.Segmented}] & {
        padding: ${spacing.base};
    }
`;

const Heading = styled(Subtitle2)`
  flex-grow: 1;
  margin: 0;
`;

const Subtitle = styled(Body2)`
    width: 100%;
    margin: 0;
    color: ${colors.textSecondary};
`;

const LinkWrapper = styled.div`
  flex-shrink: 0;
`;

type PopoverTitleProps = PropsWithChildren<{
  LinkContent?: ReactNode;
  subtitle?: string;
}>;

export const PopoverTitle = ({ children, LinkContent, subtitle }: PopoverTitleProps) => {
  return (
    <TitleWrapper>
      <FlexSpacer alignItems="flex-start" gap="base">
        <Heading>{children}</Heading>
        {LinkContent && <LinkWrapper>{LinkContent}</LinkWrapper>}
      </FlexSpacer>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </TitleWrapper>
  );
};
